module.exports = __webpack_public_path__ + "static/puck-side-tablet-e1178f852d3e955917433639327e0707.jpg";